import {Injectable} from '@angular/core';
// @ts-ignore
import * as defaultText from '../../../assets/languages/en/text.json'
import {LANGUAGES} from "./language.config";
import {COUNTRIES_SHORT} from "../../config/countries.config";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  activeLanguageKey = 'activeLanguage';
  defaultLanguage = LANGUAGES.english;
  defaultLanguageText = (defaultText as any)['default'];

  activeLanguage = new BehaviorSubject(LANGUAGES.english);
  activeLanguageText = null;
  mexicoDomain = '192.168.0.101';

  constructor() {
    //this.detectLanguage();
  }

  detectLanguage() {
    localStorage.setItem('country', COUNTRIES_SHORT.usa);
    if (this.activeLanguage.value === LANGUAGES.spanish) {
      localStorage.setItem('country', COUNTRIES_SHORT.mexico);
    }
    this.getLanguageText(this.activeLanguage.value);
  }

  setActiveLanguage(lang?: string) {
    const newLang = lang ? lang : this.defaultLanguage;
    this.activeLanguage.next(newLang);
    localStorage.setItem(this.activeLanguageKey, newLang);
    this.detectLanguage();
  }

  getActiveLanguage(): string {
    return String(localStorage.getItem(this.activeLanguageKey));
  }

  removeActiveLanguage() {
    this.activeLanguage.next(this.defaultLanguage);
    this.getLanguageText(this.activeLanguage.value);
    localStorage.removeItem(this.activeLanguageKey);
  }

  getLanguageText(lang: string) {
    const rawFile = new XMLHttpRequest();
    rawFile.open("GET", `./assets/languages/${lang}/text.json`, false);
    rawFile.onreadystatechange = () => {
      if(rawFile.readyState === 4)  {
        if(rawFile.status === 200 || rawFile.status == 0) {
          this.activeLanguageText = JSON.parse(rawFile.responseText);
          console.log('lang', this.activeLanguage)
        }
      }
    };
    rawFile.send(null);
  }

  getString(value: string, innerVal?: string) {
    if (this.activeLanguageText && this.activeLanguageText[value]) {
      if (innerVal) {
        if (this.activeLanguageText[value][innerVal]) {
          return this.activeLanguageText[value][innerVal]
        } else {
          return this.defaultLanguageText[value][innerVal];
        }
      } else {
        return this.activeLanguageText[value];
      }
    }
    if (innerVal) {
      return this.defaultLanguageText[value][innerVal];
    }
    return this.defaultLanguageText[value];
  }

  replaceVariables(string: string, vars: any) {
    vars.forEach((variable: any) => {
      string = string.replace(`{{${Object.keys(variable)[0]}}}`, variable[Object.keys(variable)[0]]);
    });
    return string;
  }

  getStringWithVariables(vars: any, value: string, innerVal?: string) {
    const string = this.getString(value, innerVal);
    return this.replaceVariables(string, vars);
  }

  getStringFirstCharCapital(value: string, innerVal?: string) {
    const str = this.getString(value, innerVal);
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
